import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import fetchLiquidationDownload from './fetchLiquidationsDownload'

export const liquidationsDownloadAdapter = createEntityAdapter()

export const liquidationsDownloadSlicer = createSlice({
  name: 'liquidations/download',
  initialState: liquidationsDownloadAdapter.getInitialState({
    status: 'idle',
    url: {},
    errors: null
  }),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchLiquidationDownload.pending, state => {
      state.status = 'loading'
    })
    builder.addCase(
      fetchLiquidationDownload.rejected,
      (state, { payload }) => {
        state.status = 'error'
        state.errors = payload
      }
    )
    builder.addCase(
      fetchLiquidationDownload.fulfilled,
      (state, { payload }) => {
        state.status = 'finished'
        state.url = payload
      }
    )
  }
})

const reducer = liquidationsDownloadSlicer.reducer
export default reducer
